import { BaseApiDataResponse } from './../../../Models/ApiData';
import { XHRRequestCanceler } from '../../../../Libs/xhr/XHRRequestCanceler';
import {
    ControleTemplateDataServiceName,
    IControleTemplateDataService,
} from '../../../DataServices/ControleTemplateDataService';
import { Lazy } from '../../../Helpers/Lazy';
import {
    CheckTemplateListResponse,
    CheckTemplateResponse,
    SetCheckTemplate,
} from '../../../Models/Control/ControleTemplates';
import { IoC } from '../../ServicesContainer';
import { BaseReduxService } from '../Api/BaseReduxService';

export interface IControleTemplateService {
    getCheckTemplateList: (
        params: {
            isActive?: boolean;
            count?: number;
        },
        cts?: XHRRequestCanceler
    ) => Promise<CheckTemplateListResponse>;
    createCheckTemplate: (
        body: SetCheckTemplate,
        cts?: XHRRequestCanceler
    ) => Promise<CheckTemplateResponse>;

    getCheckTemplate: (id: string, cts?: XHRRequestCanceler) => Promise<CheckTemplateResponse>;

    updateCheckTemplate: (
        id: string,
        body: SetCheckTemplate,
        cts?: XHRRequestCanceler
    ) => Promise<CheckTemplateResponse>;

    deleteCheckTemplate: (id: string, cts?: XHRRequestCanceler) => Promise<BaseApiDataResponse>;

    dispatchPage: (page: number) => void;
}

class ControleTemplateService extends BaseReduxService implements IControleTemplateService {
    private readonly controleTemplateDataService: Lazy<IControleTemplateDataService>;

    constructor() {
        super();
        this.controleTemplateDataService = IoC.getLazy<IControleTemplateDataService>(
            ControleTemplateDataServiceName
        );
    }

    public getCheckTemplateList = async (
        params: {
            isActive?: boolean;
            count?: number;
        },
        cts?: XHRRequestCanceler
    ): Promise<CheckTemplateListResponse> => {
        try {
            const reponse: CheckTemplateListResponse = await this.controleTemplateDataService
                .value()
                .getCheckTemplateList(params, cts);

            return reponse;
        } catch (error) {
            throw new Error(error);
        }
    };

    public createCheckTemplate = async (
        body: SetCheckTemplate,
        cts?: XHRRequestCanceler
    ): Promise<CheckTemplateResponse> => {
        try {
            const response: CheckTemplateResponse = await this.controleTemplateDataService
                .value()
                .createCheckTemplate(body, cts);

            return response;
        } catch (error) {
            throw new Error(error);
        }
    };

    public getCheckTemplate = async (
        id: string,
        cts?: XHRRequestCanceler
    ): Promise<CheckTemplateResponse> => {
        try {
            const response: CheckTemplateResponse = await this.controleTemplateDataService
                .value()
                .getCheckTemplate(id, cts);

            return response;
        } catch (error) {
            throw new Error(error);
        }
    };

    public updateCheckTemplate = async (
        id: string,
        body: SetCheckTemplate,
        cts?: XHRRequestCanceler
    ): Promise<CheckTemplateResponse> => {
        try {
            const response: CheckTemplateResponse = await this.controleTemplateDataService
                .value()
                .updateCheckTemplate(id, body, cts);

            return response;
        } catch (error) {
            throw new Error(error);
        }
    };
    public deleteCheckTemplate = async (
        id: string,
        cts?: XHRRequestCanceler
    ): Promise<BaseApiDataResponse> => {
        try {
            const response: BaseApiDataResponse = await this.controleTemplateDataService
                .value()
                .deleteCheckTemplate(id, cts);

            return response;
        } catch (error) {
            throw new Error(error);
        }
    };

    public dispatchPage = (page: number): void => {
        this.dispatch({
            action: '',
            payload: { page },
        });
    };
}

const ControleTemplateServiceName: string = 'ControleTemplateService';
export { ControleTemplateService, ControleTemplateServiceName };
